<template>
  <v-expansion-panels v-model="panelIndex" flat :style="{ width: panelIndex === 0 ? '100%' : 'fit-content' }">
    <v-expansion-panel>
      <v-expansion-panel-title>
        <div class="title-container">
          <TextBody v-if="count" tag="span" :text="count" :body-type="2" color="#000" />
          <BbIcon v-if="iconName" size="small" :name="iconName" />
          <TextBody tag="span" :text="title" :body-type="2" weight="medium" />
          <span v-if="collectionName" class="collection-name"> from {{ collectionName }}</span>
        </div>
        <template #actions>
          <BbBtn
            class="action-button"
            size="x-small"
            type="icon"
            :icon="panelIndex === 0 ? 'chevron-up' : 'chevron-down'"
            icon-size="small"
            no-background
          />
        </template>
      </v-expansion-panel-title>
      <v-expansion-panel-text>
        <slot></slot>
      </v-expansion-panel-text>
    </v-expansion-panel>
  </v-expansion-panels>
</template>
<script setup>
import { ref, watch, nextTick, defineProps, defineEmits } from 'vue';

import TextBody from '~/components/common/TextBody';

const props = defineProps({
  title: { type: String, default: '' },
  collectionId: { type: String, default: '' },
  collectionName: { type: String, default: '' },
  modelValue: { type: Boolean, default: false },
  iconName: { type: String, default: '' },
  count: { type: String, default: '' },
});

const emit = defineEmits(['update:modelValue']);

const panelIndex = ref(null);

nextTick(() => {
  panelIndex.value = props.modelValue ? 0 : null;
});

watch(panelIndex, (val) => {
  const isOpen = val != null;
  if (isOpen !== props.modelValue) {
    emit('update:modelValue', isOpen);
  }
});

watch(
  () => props.modelValue,
  (val) => {
    if ((panelIndex.value != null) !== val) {
      panelIndex.value = val ? 0 : null;
    }
  },
);
</script>

<style scoped lang="scss">
.collection-name {
  @include bb-regular-text-styles('lg');
  font-weight: 500;
  margin-left: $bb-spacing-1;
  cursor: pointer;
}

.title-container {
  display: flex;
  align-items: center;
  gap: $bb-spacing-2;

  :deep(.font-weight-regular) {
    font-weight: 700 !important;
  }
}
</style>
